import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, className, ...props }) => {
  if (icon) {
    const IconComponent = icon;
    return <IconComponent className={className} {...props} />;
  }
  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;